import AddIcon from '@mui/icons-material/Add';
import { IconButton } from '@mui/material';
import React from 'react';
import EdButton from '../EdButton';
import LegacyHidden from '../LegacyHidden';

type Props = {
  adicionar?: () => void;
};

const BotaoAdicionar: React.FC<Props> = (props) => {
  const { adicionar } = props;

  if (adicionar === undefined) {
    return null;
  }

  return (
    <>
      <LegacyHidden smDown>
        <EdButton
          size="small"
          onClick={() => adicionar()}
          startIcon={<AddIcon />}
          style={{ marginLeft: 5 }}
        >
          ADICIONAR
        </EdButton>
      </LegacyHidden>

      <LegacyHidden mdUp>
        <IconButton onClick={() => adicionar()}>
          <AddIcon />
        </IconButton>
      </LegacyHidden>
    </>
  );
};

export default BotaoAdicionar;
